<template>
    <div>
        <div class="aFlex fchart-box-top">
            <span class="ft-bold">工资发放情况</span>
            <span class="ft-gray" style="margin-left: 10px">默认统计系统日期上个月</span>
        </div>
        <div class="fchart-bi" ref="salaryBarLine">工资发放情况</div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: "salaryBarLine",
        data() {
            return {
                // 工资发放统计
                salaryBarLine:null,
            }
        },
        computed: {
            ...mapState(['area']),
        },
        props: {
            areaCode:{
                type: [String,Number]
            },
            dateMonth:{
                type: [String,Number]
            },
        },
        mounted() {
            //引入echarts 初始化图标
            let echarts = require('echarts');
            // 工资发放情况
            this.salaryBarLine = echarts.init(this.$refs.salaryBarLine);
            //初始化 setOption
            this.initChart();
            //获取数据
            this.getData();
            window.addEventListener('resize',this.resize);
            window.addEventListener('load',this.resize);
            /*加载完成自适应*/
            this.$nextTick( ()=> {
                this.resize();
            });
        },
        methods: {
            // echarts 适应
            resize(){
                this.salaryBarLine.resize();
            },
            initChart(){
                this.salaryBarLine.setOption(
                    {
                        legend: {
                            orient: 'horizontal',
                            top: 8,
                            left: 'center',
                            icon:'rect',
                        },
                        tooltip: {
                            // trigger: 'item',
                            // formatter: '{a}\n {b}: {c}',
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid:{
                            left: 30,
                            right:30,
                            top: 50,
                            bottom: 8,
                            containLabel: true
                        },
                        xAxis:{
                            name:'',
                            nameTextStyle:{
                                align:'right',
                                padding:[30,30,0,0]
                            },
                            /* 类目轴*/
                            type:'category',
                            axisLabel:{
                                interval:0,
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            data:[],
                        },
                        yAxis: [
                            {
                                position: 'left',
                                name:'数量',
                                nameTextStyle:{
                                    align:'right',
                                    // padding:[0]
                                },
                                splitLine: {
                                    show: true, //网格线开关
                                    lineStyle:{
                                        type:'dashed'
                                    }
                                },
                                axisLine:{
                                    show: false
                                },
                                minInterval: 1,
                            },
                            {
                                position: 'right',
                                name: '%',
                                nameTextStyle:{
                                    align:'right',
                                    // padding:[0]
                                },
                                splitLine: {
                                    show: true, //网格线开关
                                    lineStyle:{
                                        type:'dashed'
                                    }
                                },
                                axisLine:{
                                    show: false
                                },
                                minInterval: 1,
                            },
                        ],
                        color: [ '#3399FF','#61DDAA','#65789B','#F6BD16'],
                        series: [
                            {
                                type: 'bar',
                                name: '项目总数',
                                // barGap:'10%',
                                barCategoryGap: '10%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                            {
                                type: 'bar',
                                name: '已发放项目总数',
                                // barGap:'10%',
                                barCategoryGap: '10%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                            {
                                type: 'bar',
                                name: '未发放项目总数',
                                // barGap:'10%',
                                barCategoryGap: '10%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                            {
                                type: 'line',
                                name: '发放率',
                                data:[],
                            },
                        ]
                    }
                );
            },
            // 工资发放情况统计
            getData(){
                this.salaryBarLine.showLoading();
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryPayOffCountProvince',
                    data:{
                        areaCode:this.areaCode,
                        month:this.dateMonth,
                    }
                }).then( (response)=> {
                    this.salaryBarLine.hideLoading();
                    const xArr = response.data.areaList || [];
                    this.salaryBarLine.setOption(
                        {
                            xAxis:{
                                data: xArr,
                            },
                            series:[
                                {
                                    data: response.data.projectTotalList,
                                },
                                {
                                    data: response.data.issuedList,
                                },
                                {
                                    data: response.data.notIssuedList,
                                },
                                {
                                    data: response.data.issuedRateList,
                                }
                            ],
                            dataZoom : xArr.length > 6 ? [
                                {
                                    startValue : 0,
                                    endValue : 5,
                                    type: 'slider',
                                    show: true,
                                    xAxisIndex: [0],
                                    height: 10,
                                    bottom: 8,
                                    borderRadius: 5,
                                    showDataShadow: false,
                                    showDetail: false,
                                    realtime: true
                                }
                            ] : [],
                            grid:{
                                bottom: xArr.length > 6? 24: 8
                            },

                        }
                    );
                });
            },
        }
    }
</script>

<style scoped>

</style>
